module.exports = __webpack_public_path__ + "static/media/dallal.c1ba9a5b.jpg";